import React from "react";
import { Sparkles, Layers, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function UnsereExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "Rolltreppen- & Fahrsteig-Reinigung",
    description: "Mit den Columbus-Junker Maschinen ROTOFAST 500 und ROTOMAC 300 reinigen wir schnell, randnah und tiefenwirksam. Dank starker Absaugung bleibt kein Schmutz oder Wasser im Schacht.",
    icon: Sparkles
  }, {
    title: "Erfahrung & Vorgehen",
    description: "Seit 2000 reinigen wir Rolltreppen und Fahrsteige mit professioneller Spezialtechnik – schonend und zuverlässig. Wir arbeiten nach einem klaren Ablauf: Vorbereitung, Tiefenreinigung, Absaugung und Endkontrolle.",
    icon: Layers,
    highlight: true
  }, {
    title: "Warum regelmäßige Reinigung?",
    description: "Regelmäßige Pflege minimiert Ausfallrisiken, erhöht die Sicherheit und sorgt für einen makellosen ersten Eindruck bei Ihren Besuchern. Zusätzlich verlängert sie die Laufzeiten Ihrer Anlage und hilft, teure Reparaturen durch Verschleiß zu vermeiden.",
    icon: ShieldCheck
  }];
  return <section id="unsere-expertise" ref={ref} className="bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-8">
        <div className="mb-16 md:mb-24 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
            Unsere Expertise
          </h2>
          
        </div>

        <div className={cn("grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-start transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} data-index={index} className={cn("h-full transition-transform duration-500", feature.highlight ? "lg:-mt-8 lg:mb-8 z-10" : "z-0")}>
                <Card className={cn("h-full border rounded-2xl transition-all duration-300 flex flex-col justify-between", feature.highlight ? "bg-card shadow-2xl border-primary/10 lg:scale-105 ring-1 ring-primary/5" : "bg-background shadow-sm hover:shadow-md border-border/60 hover:border-border")}>
                  <CardHeader className="pb-6 pt-10 px-8 md:px-10">
                    <div className="mb-8 inline-flex items-center justify-start">
                      <Icon strokeWidth={1} className={cn("w-14 h-14", feature.highlight ? "text-primary" : "text-muted-foreground")} />
                    </div>
                    <CardTitle className="text-2xl font-semibold tracking-tight text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 md:px-10 pb-10">
                    <CardDescription className="text-base leading-relaxed text-muted-foreground">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}